import Model from "./base/model";

class faturaFile extends Model{
  resourceName() {
    return "fatura_files";
  }

  fields() {
    return {
      fatura_path: "",
      fatura_name: "",
      expire_date: "",
      type: "",
      purchase_orders: {jsonApi: "hasOne", type: "purchase_orders"},
      orders: {jsonApi: "hasMany", type: "orders"},
      emission_date: "",
      value: "",
      number: "",
      documents_structure: "",
      documents_issue: "",
      created_at: "",
    }
  }
}

export default new faturaFile();
